import { render, staticRenderFns } from "./AppendixLinkCard.vue?vue&type=template&id=e27167f0&scoped=true"
import script from "./AppendixLinkCard.vue?vue&type=script&lang=js"
export * from "./AppendixLinkCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e27167f0",
  null
  
)

export default component.exports